var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"my-5",attrs:{"color":"grey lighten-5","rounded":"","elevation":"1"}},[_c('v-card',{attrs:{"outlined":"","elevation":"2"}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }